import * as Types from '../../generated.types'

import { FinchConnectionDetailFragmentDoc } from '../../fragments/FinchConnectionFragment_gen'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CompleteFinchConnectionMutationVariables = Types.Exact<{
  authorizationCode: Types.Scalars['String']
  finchConnectionId: Types.Scalars['Int']
}>

export type CompleteFinchConnectionMutation = {
  __typename?: 'Mutation'
  completeFinchConnection?: {
    __typename?: 'CompleteFinchConnectionPayload'
    finchConnection: {
      __typename: 'FinchConnection'
      id: number
      sessionId?: string | null
      displayLabel?: string | null
      isActive: boolean
      status?: Types.FinchConnectionStatus | null
      hasAuthenticatedEver: boolean
    }
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CompleteFinchConnectionDocument = `
    mutation CompleteFinchConnection($authorizationCode: String!, $finchConnectionId: Int!) {
  completeFinchConnection(
    input: {authorizationCode: $authorizationCode, finchConnectionId: $finchConnectionId}
  ) {
    finchConnection {
      ...FinchConnectionDetail
    }
    inputErrors {
      argument
      message
    }
  }
}
    ${FinchConnectionDetailFragmentDoc}`
export const useCompleteFinchConnectionMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CompleteFinchConnectionMutation,
    TError,
    CompleteFinchConnectionMutationVariables,
    TContext
  >
) =>
  useMutation<CompleteFinchConnectionMutation, TError, CompleteFinchConnectionMutationVariables, TContext>(
    ['CompleteFinchConnection'],
    (variables?: CompleteFinchConnectionMutationVariables) =>
      fetchGql<CompleteFinchConnectionMutation, CompleteFinchConnectionMutationVariables>(
        CompleteFinchConnectionDocument,
        variables
      )(),
    options
  )
